export default (meters: number) => meters * 0.304_8
